import './UserInfo.scss';
import React, { useRef } from 'react';
import { ReactComponent as UpdateIcon } from '../assets/ProfileIcon.svg';
import { ReactComponent as LogoutIcon } from '../assets/LogoutIcon.svg';
import { Button } from 'primereact/button';
import { ROUTES } from '../../../config/routes';
import { useUserLogoutMutation } from '../../../services/userAuth';
import { useDispatch, useSelector } from 'react-redux';
import { resetUserCredentials, selectUser } from '../../../pages/login-page/LoginAuthSlice';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as DownloadIcon } from '../assets/DownloadIcon.svg'
import { useEffect } from 'react';
import toast from 'react-hot-toast';
import { useDownloadReportMutation } from '../../../services/attendance-portal/downloadReport';
import { downloadReportFunctionality } from './DownloadReportFunctionality';
import { getMonth, getYear } from 'date-fns';

import { OverlayPanel } from 'primereact/overlaypanel';
import { ReactComponent as DropDown } from "../assets/drop-down.svg"

function UserInfo({ setShowAdd, setShowOnboard }) {
  const [downloadMonthlyReport] = useDownloadReportMutation()
  const [logout] = useUserLogoutMutation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const handleOverlay = useRef()
  const loggedInUser = useSelector(selectUser)


  useEffect(() => {
    if (!loggedInUser?.firstName) {
      toast((t) => {
        return (
          <div className='flex justify-content-between align-items-center pl-1 pr-1 text-xs'>
            <div>Update your details here</div>
            <div className="ml-5 flex">
              <div className='font-bold cursor-pointer flex' style={{ color: '#E58526' }} onClick={() => {
                setShowOnboard()
                toast.dismiss(t.id)
              }}>Settings</div>
              <div title='Dismiss' className='cursor-pointer' onClick={() => toast.dismiss(t.id)}><i className="pi pi-times ml-2" style={{ fontSize: "0.7rem" }}></i></div>
            </div>
          </div>
        )
      }, {
        duration: Infinity,

        style: {
          background: '#4D3E35',
          border: '1px solid #E58526',
          borderRadius: '12px',
          color: '#fff'
        },
        icon: '🔥'
      })
    }
  }, [loggedInUser])

  const handleLogout = async (e) => {
    const loginURL = ROUTES.LOGIN
    const response = await logout().unwrap();
    toast.dismiss();
    navigate(loginURL)
    dispatch(resetUserCredentials())
  }

  // TODO: If only superadmin then this function should execute
  const handleDownloadReport = async () => {
    if (isSuperAdmin) {
      
      const resultFromReport = await downloadMonthlyReport()
      const attendanceReportResponse = downloadReportFunctionality(resultFromReport)
      toast.success(attendanceReportResponse)
    }
  }


  const superAdminContent = (
    <>
      
      <div >
        <div className="DownloadButton border-right-1  border-white-alpha-40 ">
          <Button className='p-button-text text-xs md:text-sm  font-medium py-0 white-space-nowrap text-overflow-ellipsis overflow-x-hidden' label="" icon={<DownloadIcon className='mr-1' />}
            onClick={handleDownloadReport} />
        </div>
      </ div>
    </>
  )


  let firstName = loggedInUser?.firstName ?? 'Update your details'
  let designation = loggedInUser?.designation ?? 'from settings ->'
  let isSuperAdmin = loggedInUser?.isSuperAdmin ?? false

  // * If development environment uncomment this part
  // let isSuperAdmin = true

  return (
    <div className="UserInfo  flex justify-content-end align-items-center">
      {isSuperAdmin && superAdminContent}
      {/* <div className=" NotificationIcon  border-right-2 border-100 px-1">
        <Button icon={<Bell />} className="p-button-rounded p-button-text py-0" />
      </div> */}
      <div className='flex cursor-pointer ml-3' onClick={(e) => handleOverlay.current.toggle(e)}  >
        <div className=" flex flex-column text-xs md:text-sm white-space-nowrap text-overflow-ellipsis overflow-x-hidden">
          <span className="FirstName font-medium ">{firstName}
          </span>
          <span className="text-xs Designation font-medium">{designation}</span>
        </div>
        {/* <i className="pi pi-chevron-down pb-3 pl-2 "></i> */}
        <DropDown />

      </div>
      <div>
        <OverlayPanel ref={handleOverlay} style={{ width: "fit-content", }} className="mt-0 text-white py-2 OverlayBackground" >
          <div
            className='flex flex-column '>
            <div className='MenuItem flex align-items-center  cursor-pointer font-semibold px-1 ' onClick={() => setShowOnboard()}>
              <div className='UpdateIcon px-2 mt-2'>
                <UpdateIcon />
              </div>
              <p className='white-space-nowrap  text-sm pl-1  pr-2'>
                Update Profile
              </p>
            </div>
            <div className='MenuItem flex align-items-center  cursor-pointer  font-semibold px-1' onClick={handleLogout}>
              <div
                className='LogOutIcon px-2 mt-2'>
                <LogoutIcon />
              </div>
              <p className=' text-sm pl-1 pr-2'>
                Log out
              </p>
            </div>
          </div>
        </OverlayPanel>
      </div>

    </div>
  );
}

export default UserInfo;
